<div #check class="root" [class]="{ on: isOn, off: !isOn }" (click)="onChange()">
  <div class="check">
    <fa-icon icon="circle-check" />
  </div>
  <div class="text">
    <ng-content />
  </div>
</div>
